import { useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { showSystemAlert } from "@/lib/push";

// Surfaces new notifications as in-app toasts + browser alerts while the app is open.
export default function PushBridge() {
  const since = useRef(new Date().toISOString());
  const prevCount = useRef(null);
  const { data: count } = useQuery({
    queryKey: ["notif-unread"],
    queryFn: async () => (await api.get("/notifications/unread-count")).data.count,
    refetchInterval: 5000,
  });

  useEffect(() => {
    if (count == null) return;
    const grew = prevCount.current != null && count > prevCount.current;
    prevCount.current = count;
    if (!grew) return;
    (async () => {
      try {
        const { data } = await api.get("/notifications");
        const fresh = data.items.filter((n) => !n.read && n.created_at > since.current);
        if (fresh.length) since.current = fresh[0].created_at;
        fresh.slice(0, 3).forEach((n) => {
          const title = n.actor?.name || (n.type === "price" ? "Price alert" : "Global Ore Exchange");
          toast(title, { description: n.text });
          showSystemAlert(title, n.text, n.link);
        });
      } catch {}
    })();
  }, [count]);

  return null;
}
